import { render } from "./CommunityView.vue?vue&type=template&id=16a08ea1&scoped=true"
import script from "./CommunityView.vue?vue&type=script&lang=js"
export * from "./CommunityView.vue?vue&type=script&lang=js"

import "./CommunityView.vue?vue&type=style&index=0&id=16a08ea1&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adoranwodo2.0/adoranwodo2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a08ea1"]])

export default __exports__